import React from "react";
import { Stack, Text, InternalLink } from "@thecb/components";
import { CHARADE_GREY } from "/constants/colors";
import { configureEndpoint } from "/util/router-utils";
import { BankIcon, CardType } from "@thecb/components";
import { NOT_AVAILABLE } from "/constants/activity_history_constants";

const CELL_TEXT_STYLES = {
  color: CHARADE_GREY,
  fontSize: "0.875rem"
};

const SMALL_TEXT_STYLES = {
  color: CHARADE_GREY,
  fontSize: "0.75rem"
};

const getPaymentIcon = (paymentType, cardType) => {
  if (paymentType?.includes("credit_card")) return <CardType type={cardType} />;
  if (paymentType?.includes("bank_account")) return <BankIcon />;
  return null;
};

// Blank cell intentionally rendered when audit entry does not need additional data coming from the display cache
const NonAvailableCell = () => (
  <Text {...CELL_TEXT_STYLES}>{NOT_AVAILABLE}</Text>
);

const AgencyLinkOrText = ({ activity, customerManagement, linkColor }) => {
  if (!activity.accountURL) {
    return <Text {...CELL_TEXT_STYLES}>{activity.agency}</Text>;
  }

  return (
    <InternalLink
      to={configureEndpoint(customerManagement, activity.accountURL)}
      color={linkColor}
      fontSize="0.875rem"
      isUnderlined={false}
      hoverUnderlined={true}
    >
      {activity.agency}
    </InternalLink>
  );
};

const renderCellContent = (activity, customerManagement, linkColor) => {
  if (activity.paymentType) {
    return (
      <Stack direction="row" align="center" childGap="0.25rem">
        {getPaymentIcon(activity.paymentType, activity.cardType)}
        <Text {...CELL_TEXT_STYLES}>{activity.paymentLastFour}</Text>
      </Stack>
    );
  }

  if (activity.agency) {
    return (
      <>
        <AgencyLinkOrText
          activity={activity}
          customerManagement={customerManagement}
          linkColor={linkColor}
        />
        {activity.account && (
          <Text {...SMALL_TEXT_STYLES}>Account: {activity.account}</Text>
        )}
      </>
    );
  }

  return <NonAvailableCell />;
};

const ActivityCell = ({ activity, customerManagement, linkColor }) => {
  return (
    <Stack childGap="0.125rem">
      {renderCellContent(activity, customerManagement, linkColor)}
    </Stack>
  );
};

export default ActivityCell;
